var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "div",
        { staticClass: "exchange-detail" },
        [
          _c("i", { staticClass: "iconhuobi iconfont info-icon" }),
          _c("div", [
            _c("div", { staticClass: "exchange-info" }, [
              _vm._v(
                " 1 " +
                  _vm._s(_vm.$t("system::exchange-manager::dollar")) +
                  " = " +
                  _vm._s(_vm.exchange) +
                  " "
              ),
              _vm._v(
                " " + _vm._s(_vm.$t("system::exchange-manager::rmb")) + " "
              ),
            ]),
            _c("p", { staticClass: "tips-info" }, [
              _vm._v(_vm._s(_vm.$t("system::exchange-manager::title"))),
            ]),
          ]),
          _c(
            "el-button",
            {
              staticClass: "change-btn",
              attrs: { type: "default" },
              on: { click: _vm.onShow },
            },
            [
              _c("i", { staticClass: "iconedit iconfont edit-icon" }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("system::exchange-manager::change_rate")) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
      _c("rateModal", {
        attrs: { drawRow: _vm.rateRow },
        on: { save: _vm.onSave },
        model: {
          value: _vm.rowVisable,
          callback: function ($$v) {
            _vm.rowVisable = $$v
          },
          expression: "rowVisable",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }